import { type FC, useMemo } from 'react';

import { Box, Button, Center, Flex, Stack, Text } from '@chakra-ui/react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { variantPath } from '@/utils/variant/variantPath';

import CheckCircleGif from '../../assets/images/check-circle.gif';
import { IconBrandStar, IconRightArrow } from '../../components';

export const InterviewCompletedPage: FC = () => {
  const { t } = useTranslation(['interview']);
  const navigate = useNavigate();

  const currentYear = useMemo(() => {
    return dayjs().year();
  }, []);

  return (
    <Center flex="1" bg="gray.25">
      <Flex
        flexDirection="column"
        gap={0}
        maxW="460px"
        alignItems="center"
        bg="white"
        borderColor="gray.50"
        border={1}
        borderRadius={16}
        px={8}
        py={10}
        zIndex={1}
      >
        {variantPath('Logo')}

        <Box
          width="160px"
          height="160px"
          mt={4}
          backgroundImage={CheckCircleGif}
          bgSize="cover"
          bgPosition="center"
        />

        <Text
          mb={3}
          mt={1.5}
          color="gray.900"
          fontSize="2xl"
          fontWeight="semibold"
          textAlign="center"
        >
          {t('interview:completed.title')}
        </Text>

        <Text
          color="gray.600"
          fontSize="md"
          fontWeight="normal"
          textAlign="center"
        >
          {t('interview:completed.desc')}
        </Text>

        <Button
          variant="@primary"
          mt={6}
          rightIcon={<IconRightArrow fontSize="20px" />}
          onClick={() => navigate('/coach')}
        >
          {t('interview:tryInterviewCoach')}
        </Button>
      </Flex>

      <Text
        color="gray.600"
        fontWeight="normal"
        fontSize="sm"
        position="absolute"
        bottom={8}
        left="50%"
        transform="translateX(-50%)"
      >
        © Snaps.ai {currentYear}
      </Text>

      <Stack position="absolute" zIndex={0} height="100vh" width="100vw">
        <IconBrandStar
          position="absolute"
          top="4%"
          right="10%"
          fontSize="100px"
        />
        <IconBrandStar
          position="absolute"
          top="1%"
          left="10%"
          fontSize="248px"
        />
        <IconBrandStar
          position="absolute"
          bottom="6%"
          left="12%"
          fontSize="100px"
        />
        <IconBrandStar
          position="absolute"
          bottom="2%"
          right="6%"
          fontSize="314px"
        />
      </Stack>
    </Center>
  );
};
